/** 
 * @param {number} init_amount initial amount
 * @returns {{{number} fee, {number} receive}
 */
exports.calculateCommission = (init_amount) => {
    let fee, receive;
    if (init_amount > 2000) {
        fee = init_amount * 0.2;
    }
    else if (init_amount <= 2000 && init_amount > 1500) {
        fee = 150;
    }
    else if (init_amount <= 1500 && init_amount > 1000) {
        fee = 100;
    }
    else if (init_amount <= 1000 && init_amount > 800) {
        fee = 80;
    }
    else if (init_amount <= 800 && init_amount > 300) {
        fee = 50;
    }
    else if (init_amount <= 300 && init_amount > 200) {
        fee = 40;
    }
    else if (init_amount <= 250 && init_amount > 200) {
        fee = 35;
    }
    else if (init_amount <= 200 && init_amount > 150) {
        fee = 30;
    }
    else if (init_amount <= 150 && init_amount > 100) {
        fee = 25;
    }
    else if (init_amount <= 100) {
        fee = 20;
    }
    receive = init_amount - fee;
    return {
        fee: fee,
        receive: receive
    }
}
